"use strict";
module.exports = {
    'v1.integration.createIntegration': 'integration',
    'v1.integration.activate': 'integration',
    'v1.integration.deactivate': 'integration',
    'v1.integration.sendTechnicalEmail': 'integration',
    'v1.integration.setUpExternalFortnoxConnection': 'integration',
    'v1.integration.updateFortnoxIntegration': 'integration',
    'v1.integration.ensureRecycleArticlesInExternalFortnox': 'integration',
    'v1.integration.setUpInternalFortnoxConnection': 'integration',
    'v1.integration.setUpExtendConnection': 'integration',
    'v1.integration.setUpWhgroupConnection': 'integration',
    'v1.integration.resetIntegrationRun': 'integration',
    'v1.integration.startIntegrationRun': 'integration',
    'v1.integration.stopIntegrationRun': 'integration',
    'v1.integration.triggerScheduledRun': 'integration',
    'v1.integration.deactivateIncoming': 'integration',
    'v1.integration.activateIncoming': 'integration',
    'v1.integration.deactivateOutgoing': 'integration',
    'v1.integration.activateOutgoing': 'integration',
    'v1.integration.deactivateGetEndpoint': 'integration',
    'v1.integration.activateGetEndpoint': 'integration',
    'v1.integration.deactivateScheduledRun': 'integration',
    'v1.integration.activateScheduledRun': 'integration',
    'v1.integration.upsert': 'integration',
    'v1.integration.upsertWhenEmpty': 'integration',
    'v1.integration.updateWhenEmpty': 'integration',
    'v1.integration.update': 'integration',
    'v1.mappingTemplate.writeMappingTemplate': 'integration',
    'v1.mappingTemplate.upsert': 'integration',
    'v1.mappingTemplate.upsertWhenEmpty': 'integration',
    'v1.mappingTemplate.updateWhenEmpty': 'integration',
    'v1.mappingTemplate.update': 'integration',
    'v1.oauthToken.upsert': 'integration',
    'v1.oauthToken.upsertWhenEmpty': 'integration',
    'v1.oauthToken.updateWhenEmpty': 'integration',
    'v1.oauthToken.update': 'integration',
    'v1.outgoingMessage.writeFtpFile': 'integration',
    'v1.outgoingMessage.resendEvent': 'integration',
    'v1.outgoingMessage.writeOutgoingIntegrationMessage': 'integration',
    'v1.outgoingMessage.writeOutgoingMessage': 'integration',
    'v1.outgoingMessage.upsert': 'integration',
    'v1.outgoingMessage.upsertWhenEmpty': 'integration',
    'v1.outgoingMessage.updateWhenEmpty': 'integration',
    'v1.outgoingMessage.update': 'integration',
    'v1.incomingMessage.writeIncomingMessage': 'integration',
    'v1.incomingMessage.retry': 'integration',
    'v1.incomingMessage.upsert': 'integration',
    'v1.incomingMessage.upsertWhenEmpty': 'integration',
    'v1.incomingMessage.updateWhenEmpty': 'integration',
    'v1.incomingMessage.update': 'integration',
    'v1.failedActionCall.writeFailedActionCall': 'integration',
    'v1.failedActionCall.retry': 'integration',
    'v1.failedActionCall.markAsObsolete': 'integration',
    'v1.failedActionCall.upsert': 'integration',
    'v1.failedActionCall.upsertWhenEmpty': 'integration',
    'v1.failedActionCall.updateWhenEmpty': 'integration',
    'v1.failedActionCall.update': 'integration',
    'v1.integrationEventsource.cleanUpOldEvents': 'integration',
    'v1.integrationEventsource.undoEvent': 'integration',
    'v1.integrationEventsource.reEmit': 'integration',
};
